<div class="count-row">
    @for (count of countsSorted(); track $index) {
        <div class="count-cell">
            <div class="count-number">{{ count.value | number }}</div>
            <div class="count-label">{{ count.label }}</div>
        </div>
    }
</div>
